import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import { WaitlistStatusBar } from './components/WaitlistStatusBar';
import FeedbackForm from './components/FeedbackForm';
import { Footer } from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Demo from './pages/Demo';
import Progress from './pages/Progress';
import QA from './pages/QA';
import Privacy from './pages/Privacy';
import Waitlist from './pages/Waitlist';
import { usePageTracking } from './lib/analytics';
import { PageTransition } from './components/animations/PageTransition';

// Wrapper component to handle analytics
function AppContent() {
  usePageTracking();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />
      <WaitlistStatusBar />
      <main className="flex-grow">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageTransition><Home /></PageTransition>} />
            <Route path="/about" element={<PageTransition><About /></PageTransition>} />
            <Route path="/demo" element={<PageTransition><Demo /></PageTransition>} />
            <Route path="/progress" element={<PageTransition><Progress /></PageTransition>} />
            <Route path="/qa" element={<PageTransition><QA /></PageTransition>} />
            <Route path="/privacy" element={<PageTransition><Privacy /></PageTransition>} />
            <Route path="/waitlist" element={<PageTransition><Waitlist /></PageTransition>} />
          </Routes>
        </AnimatePresence>
      </main>
      <FeedbackForm />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;